import { render, staticRenderFns } from "./SensorsPage.vue?vue&type=template&id=ecc19b48&"
import script from "./SensorsPage.vue?vue&type=script&lang=js&"
export * from "./SensorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports